class Validation {
	static validEmail(email) {
		let pattern = /(^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)+$)/gi;
		return pattern.test(email);
	}

	static validPasswd(passwd) {
		//let pattern =/((?=.*\d)(?=.*[a-zA-Z]).{6,20})/g;  // <-- pattern from the internet
		// better pattern for password  (?<!(\S|\s))(?=.*\d)(?=.*[a-zA-Z])(?=.*[$!%&*]).{6,20}(?!(\S|\s))
		// <-- this pattern looks for anything before and after the max 20 and fails to match if there is more than 20
	
		// let pattern = /(?<!(\S|\s))(?=.*\d)(?=.*[a-zA-Z])(?=.*[$!%&*]).{6,20}(?!(\S|\s))/g; // <- safari browser can't do negative lookahead
		// let pattern = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[$!%@&#*%^?])[\S]{6,20}$/g;
		let pattern = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*(){}\-_=+\[\];:\'\"\\,<.>|/?])[\S]{6,20}$/g;
		return pattern.test(passwd);
	}

	constructor(form, actionButton, checkChanges) {
		this._form = ge(form);
		this._button = ge(actionButton);
		this._validationFields = [];
		this._email;
		this._username;
		this._failCount = 0;
		this._checkChanges = checkChanges || false;

		onEv(actionButton, 'mousedown touchstart', this.disarm.bind(this));
		this.init();
	}

	init() {
		for (let i = 0, ii = this._form.elements.length; i < ii; i++) {
			let elem = this._form.elements[i];
			if (elem.hasAttribute('data-validation')){
				this._validationFields.push(elem);
				onEv(elem, 'focus', this.armField.bind(this, elem));
				if (elem.type == 'checkbox' || elem.type == 'select-one') {
					onEv(elem, 'change', this.validate.bind(this));
				} else {
					onEv(elem, 'keyup', this.validate.bind(this));
					onEv(elem, 'blur', this.validate.bind(this));
					switch (elem.getAttribute('data-validation')) {
						case 'email' : this._email = elem; break;
						case 'username' : this._username = elem; break;
					}
				}
			}
		}
		this.validate();
	}
	
	armField(elem) {
		// added a delay to arming the field as focus started firing before the key up on previous field
		setTimeout(() => {
			elem.warn = true;
		}, 800);
		// elem.warn = true;
	}

	disarm() {
		this._validationFields.forEach((f) => f.warn = false);
	}

	reset() {
		this.disarm();
		this.validate();
	}

	validate() {
		this._failCount = 0;
		this._validationFields.forEach((f) => {
			switch (f.getAttribute('data-validation')) {
				case 'name' : this.validateName(f); break;
				case 'email' : this.validateEmail(f); break;
				case 'username': this.validateUsername(f); break;
				case 'password': this.validatePassword(f); break;
				case 'card-number': this.validateCardNumber(f); break;
				case 'expires': this.validateExpires(f); break;
				case 'cvv': this.validateCVV(f); break;
				case 'street': this.validateStreet(f); break;
				case 'city': this.validateCity(f); break;
				case 'country': this.validateCountry(f); break;
			}
		}, this);
		this._button.disabled = 0 < this._failCount || this.noChanges();
	}

	noChanges() {
		let change = !this._checkChanges;
		this._validationFields.forEach((f) => {
			if (f.type == 'checkbox') {
				if (f.hasAttribute('data-prev') && !!f.getAttribute('data-prev') != !!f.checked) change = true;
			}
			else {
				if (f.hasAttribute('data-prev') && f.getAttribute('data-prev') != f.value) change = true;
			}
		})
		return !change;
	}

	validateName(field) {
		if (field.value.length === 0) {
			this.showWarning(field, 'Name can not be blank');
		}
		else this.clearWarning(field);
	}

	validateEmail(field) {
		if (field.value.length === 0) {
			if (this.emailRequired) {
				this.showWarning(field, 'Email address is required');
			}
			else {
				this.clearWarning(field);
			}
			return;
		}

		if (!Validation.validEmail(field.value)) {
			this.showWarning(field, 'Email address is invalid');
			return;
		}

		if (field.hasAttribute('data-prev')) {
			if (field.getAttribute('data-prev') == field.value) {
				this.clearWarning(field);
				return;
			}
		}
	
		ajg('validation.php', ['field=email', 'value=' + encodeURI(field.value)], null, (reply) => {
			if (reply.error) {
				this.showWarning(field, reply.error);
			}
			else {
				this.clearWarning(field);
			}
			this._button.disabled = this._failCount;
		}, this);
	}
	
	validateUsername(field) {
		if (field.value.length === 0) {
			if (this.usernameRequired) {
				this.showWarning(field, _("A username is required with out an email address"));
			}
			else {
				this.clearWarning(field);
			}
			return;
		}
		
		if (field.value.length < 6) {
			this.showWarning(field, _("A username must be a least 6 characters long"));
			return;
		}
		
		if (field.hasAttribute('data-prev') && field.getAttribute('data-prev') == field.value) {
			this.clearWarning(field);
			return;
		}
		
		ajg('validation.php', ['field=username', 'value=' + encodeURI(field.value)], null, (reply) => {
			if (reply.error) {
				this.showWarning(field, reply.error);
			}
			else {
				this.clearWarning(field);
			}
			this._button.disabled = this._failCount;
		}, this);
	}

	validatePassword(field) {
		if (field.hasAttribute('data-prev') && field.getAttribute('data-prev') == field.value) {
			this.clearWarning(field);
			return;
		}
		
		if (!Validation.validPasswd(field.value)) {
			this.showWarning(field, _("6 to 20 characters with letter, numbers and symbols"))
		}
		else this.clearWarning(field);
	}

	validateCardNumber(field) {
		if (field.value.length == 0) {
			this.showWarning(field, _("Please enter a card number"));
		}
		else {
			this.clearWarning(field);
		}
	}

	validateExpires(field) {
		if (field.value.length == 0) {
			this.showWarning(field, _("Expiry date is required"));
		}
		else {
			this.clearWarning(field);
		}
	}

	validateCVV(field) {
		if (field.value.length == 0) {
			this.showWarning(field, _("Security code is required"));
		}
		else {
			this.clearWarning(field);
		}
	}

	validateStreet(field) {
		if (field.value.length == 0) {
			this.showWarning(field, _("Street address is required"));
		}
		else {
			this.clearWarning(field);
		}
	}

	validateCity(field) {
		if (field.value.length == 0) {
			this.showWarning(field, _("Town/City is required"));
		}
		else {
			this.clearWarning(field);
		}
	}

	validateCountry(field) {
		if (field.value == 0) {
			this.showWarning(field, _("Country address is required"));
		}
		else {
			this.clearWarning(field);
		}
	}
	get emailRequired() {
		if (this._email.hasAttribute('data-required')) return true;
		return typeof this._username === 'undefined' || this._username.value.length === 0;
	}

	get usernameRequired() {
		return typeof this._email === 'undefined' || this._email.value.length === 0;
	}

	showWarning(elem, message) {
		this._failCount++;

		if (!elem.warn) return;

		elem.nextElementSibling.innerText = message;
		state(elem, 'warn');
	}

	clearWarning(elem) {
		elem.nextElementSibling.innerText = '';
		state(elem, 'norm');
	}
}